<template>
  <div>
    <div class="display__badges mt-4 mr-auto px-2">
      <div v-for="(category, index) in categories" :key="index">
        <b-badge
          ref="badgesCategoryName"
          variant="neutral-dark"
          class="text-dark badge__categories mr-3 my-1"
        >
          <b class="tag__category mr-2">
            {{ category.name }}
          </b>
          <button
            ref="buttonRemoveCategory"
            class="button__delete-category"
            variant="neutral-dark"
            @click="removeCategoryByIndex(index)"
          >
            <font-awesome-icon icon="xmark" />
          </button>
        </b-badge>
      </div>
      <button
        v-if="categories.length"
        ref="buttonClearAllCategories"
        class="button__clear-all-category"
        @click="removeAllCategory()"
      >
        Clear All
      </button>
    </div>
  </div>
</template>

<script>
import Category from '@/models/Category';

export default {
  model: {
    prop: 'vModel',
    event: 'change'
  },
  props: {
    vModel: {
      type: Array,
      requried: true,
      default: () => []
    }
  },

  computed: {
    categories: {
      get() {
        return this.vModel
          .map((slug) => {
            const category = Category.query().where('slug', slug).first();

            return category;
          })
          .filter(Boolean);
      },

      set(v) {
        this.$emit('change', v);
      }
    }
  },
  methods: {
    removeCategoryByIndex(index) {
      let { categories } = this;

      categories.splice(index, 1);

      this.categories = [...categories.map(({ slug }) => slug)];
    },
    removeAllCategory() {
      this.categories = [];
    }
  }
};
</script>

<style lang="scss" scoped>
.display__badges {
  display: flex;
  flex-wrap: wrap;
}

.badge__categories {
  display: flex;
  align-items: center;
  text-transform: capitalize;
  border-radius: 10.4px;
  padding: 4px 16px;
  height: 30px;
}

.button__delete-category {
  display: flex;
  align-items: center;
  background-color: transparent;
  color: #3b3e66;
  border: none;
  padding: 0;
  margin: 0;
  font-size: 16px;
}

.tag__category {
  font-size: 15.2px;
}

.button__clear-all-category {
  background-color: transparent;
  border: none;
  font-weight: 700;
  font-size: 15.2px;
  text-align: center;
  color: #3c44b1;
}
</style>
